import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled.tsx";
import { FormControl, Select, Typography } from "@mui/material";
import { use } from "react";
import type { ConditionEqualityType } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import ConditionFilterOptionsContext from "./ConditionFilterOptionsContext.ts";
import { conditionOperatorOptions } from "./conditionOperatorOptions.ts";

interface Props {
  value: ConditionEqualityType;
  disabled?: boolean;
  onChange: (equalityType: ConditionEqualityType) => void;
}

const ConditionOperatorSelect = ({ value, disabled, onChange }: Props) => {
  const { operators } = use(ConditionFilterOptionsContext);
  return (
    <FormControl fullWidth>
      <Select
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        sx={{ ".MuiOutlinedInput-notchedOutline": { borderColor: "divider" } }}
      >
        {conditionOperatorOptions
          .filter((option) => operators.includes(option.value))
          .map((option) => (
            <MenuItemStyled key={option.value} value={option.value}>
              <Typography>{option.caption}</Typography>
            </MenuItemStyled>
          ))}
      </Select>
    </FormControl>
  );
};

export default ConditionOperatorSelect;
